/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var CloudRunJobCPU;
(function (CloudRunJobCPU) {
    CloudRunJobCPU["_1000M"] = "1000m";
    CloudRunJobCPU["_2000M"] = "2000m";
    CloudRunJobCPU["_4000M"] = "4000m";
    CloudRunJobCPU["_6000M"] = "6000m";
    CloudRunJobCPU["_8000M"] = "8000m";
})(CloudRunJobCPU || (CloudRunJobCPU = {}));
